import _objectSpread from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
var _CONTENT_TYPE_ENUM;
import { PageNameEnum, Track } from '@/utils/track';
import { ContentType } from '@/api/affiliate/serv/oec_affiliate_invitation_api';
import { CreatorListViewModeEnum } from './creator-marketplace/constants';
import { QueryDetailedTypeEnum, getQueryDetailedType } from './creator-marketplace/utils';
var creatorMarketplaceTrack = new Track({
  pageName: PageNameEnum.CreatorMarketplace
});
var targetInvitationListTrack = new Track({
  pageName: PageNameEnum.TargetInvitationList
});
var FiledNameEnum = /*#__PURE__*/function (FiledNameEnum) {
  FiledNameEnum["CREATOR_NAME"] = "creator_name";
  FiledNameEnum["PRODUCT_NAME"] = "product_name";
  FiledNameEnum["IN_CONTENT_HASHTAG"] = "in_content_hashtag";
  FiledNameEnum["IN_CONTENT_MENTION"] = "in_content_mention";
  FiledNameEnum["IN_CONTENT_KEYWORD"] = "in_content_keyword";
  return FiledNameEnum;
}(FiledNameEnum || {});
var getQueryFieldName = function getQueryFieldName(query, type) {
  var detailedType = getQueryDetailedType(query, type);
  switch (detailedType) {
    case QueryDetailedTypeEnum.CREATOR_SUG:
      return FiledNameEnum.CREATOR_NAME;
    case QueryDetailedTypeEnum.PRODUCT_SUG:
    case QueryDetailedTypeEnum.PRODUCT_HINT:
      return FiledNameEnum.PRODUCT_NAME;
    case QueryDetailedTypeEnum.CONTENT_SUG_HASHTAG:
    case QueryDetailedTypeEnum.CONTENT_HINT_HASHTAG:
      return FiledNameEnum.IN_CONTENT_HASHTAG;
    case QueryDetailedTypeEnum.CONTENT_SUG_MENTION:
    case QueryDetailedTypeEnum.CONTENT_HINT_MENTION:
      return FiledNameEnum.IN_CONTENT_MENTION;
    default:
    case QueryDetailedTypeEnum.CONTENT_SUG_KEYWORD:
    case QueryDetailedTypeEnum.CONTENT_HINT_KEYWORD:
      return FiledNameEnum.IN_CONTENT_KEYWORD;
  }
};
export var TypeEnum = /*#__PURE__*/function (TypeEnum) {
  TypeEnum["PAGE"] = "page";
  TypeEnum["MODULE"] = "module";
  TypeEnum["HOVER"] = "hover";
  TypeEnum["POPUP"] = "popup";
  return TypeEnum;
}({});
export var EventNameEnum = /*#__PURE__*/function (EventNameEnum) {
  EventNameEnum["AFFILIATE_PAGE_SHOW"] = "affiliate_page_show";
  EventNameEnum["AFFILIATE_BUTTON_CLICK"] = "affiliate_button_click";
  EventNameEnum["AFFILIATE_PAGE_DURATION"] = "affiliate_page_duration";
  EventNameEnum["AFFILIATE_SUBMIT_RESULT"] = "affiliate_submit_result";
  return EventNameEnum;
}({});
var MODULE_NAME = 'affiliate_find_creators_card';
export var PageType = /*#__PURE__*/function (PageType) {
  PageType["Default"] = "default";
  PageType["Filter"] = "filter";
  PageType["Search"] = "search";
  PageType["SearchFilter"] = "search_filter";
  PageType["Sort"] = "sort";
  return PageType;
}({});
export var CreatorMarketplaceClickForEnum = /*#__PURE__*/function (CreatorMarketplaceClickForEnum) {
  CreatorMarketplaceClickForEnum["Search"] = "search";
  CreatorMarketplaceClickForEnum["CategoryFilter"] = "category_filter";
  CreatorMarketplaceClickForEnum["CreatorFilter"] = "creator_filter";
  CreatorMarketplaceClickForEnum["FollowersFilter"] = "followers_filter";
  CreatorMarketplaceClickForEnum["OthersFilter"] = "others_filter";
  CreatorMarketplaceClickForEnum["BlackFridayCampaignFilter"] = "affiliate_find_creator_campaign_filter";
  CreatorMarketplaceClickForEnum["ListView"] = "list_view";
  CreatorMarketplaceClickForEnum["CardView"] = "card_view";
  CreatorMarketplaceClickForEnum["GMVSort"] = "gmv_sort";
  CreatorMarketplaceClickForEnum["RelevanceSort"] = "relevance";
  CreatorMarketplaceClickForEnum["LiveWatchUVSort"] = "live_watch_uv_sort";
  CreatorMarketplaceClickForEnum["VideoViewSort"] = "video_view_sort";
  CreatorMarketplaceClickForEnum["FollowersSort"] = "followers_sort";
  CreatorMarketplaceClickForEnum["Message"] = "message";
  CreatorMarketplaceClickForEnum["AuthorDetails"] = "author_details";
  CreatorMarketplaceClickForEnum["Invite"] = "invite";
  CreatorMarketplaceClickForEnum["SavedCreators"] = "saved_creators";
  CreatorMarketplaceClickForEnum["CreatorSave"] = "creator_save";
  CreatorMarketplaceClickForEnum["CreatorUnsave"] = "creator_unsave";
  CreatorMarketplaceClickForEnum["TargetInvite"] = "target_invite";
  CreatorMarketplaceClickForEnum["CreatorDetailFilter"] = "creator_detail_filter";
  CreatorMarketplaceClickForEnum["FollowerDetailFilter"] = "follower_detail_filter";
  CreatorMarketplaceClickForEnum["PerformanceDetailFilter"] = "performance_detail_filter";
  CreatorMarketplaceClickForEnum["SortValueClick"] = "sort";
  CreatorMarketplaceClickForEnum["FilterValueClick"] = "filter";
  return CreatorMarketplaceClickForEnum;
}({});
export var SettingType = /*#__PURE__*/function (SettingType) {
  SettingType["Recommended"] = "recommended";
  SettingType["RecommendedIcon"] = "recommended_icon";
  return SettingType;
}({});
export var CONTENT_TYPE_ENUM = (_CONTENT_TYPE_ENUM = {}, _CONTENT_TYPE_ENUM[ContentType.ContentType_NoPrefer] = 'no_preference', _CONTENT_TYPE_ENUM[ContentType.ContentType_Video] = 'short_video', _CONTENT_TYPE_ENUM[ContentType.ContentType_Live] = 'live', _CONTENT_TYPE_ENUM);
export var CampaignTypeEnum = /*#__PURE__*/function (CampaignTypeEnum) {
  CampaignTypeEnum["BlackFridayCampaign"] = "campaign_creators";
  return CampaignTypeEnum;
}({});
export var CreatorTableHoverEnum = /*#__PURE__*/function (CreatorTableHoverEnum) {
  CreatorTableHoverEnum["GMV_METRIC_INFO"] = "GMV_metric_info";
  CreatorTableHoverEnum["UNITS_SOLD_INFO"] = "units_sold__info";
  CreatorTableHoverEnum["VIDEO_VIEW_METRIC_INFO"] = "video_view_metric_info";
  CreatorTableHoverEnum["ENGAGEMENT_RATE_METRIC_INFO"] = "engagement_rate_metric_info";
  CreatorTableHoverEnum["AUTHORIZED_INFO"] = "authorized_info";
  CreatorTableHoverEnum["GMV_METRIC_DETAIL"] = "GMV_metric_detail";
  CreatorTableHoverEnum["VIDEO_VIEW_METRIC_DETAIL"] = "video_view_metric_detail";
  CreatorTableHoverEnum["ENGAGEMENT_RATE_METRIC_DETAIL"] = "engagement_rate_metric_detail";
  return CreatorTableHoverEnum;
}({});
export var trackCreatorMarketplacePageShow = function trackCreatorMarketplacePageShow(params) {
  var reqId = params.reqId,
    viewName = params.viewName,
    pageType = params.pageType,
    searchKey = params.searchKey,
    searchParam = params.searchParam,
    searchTerms = params.searchTerms,
    resultCnt = params.resultCnt,
    enterFrom = params.enterFrom,
    tabName = params.tabName,
    inFilterExperimentGroup = params.inFilterExperimentGroup;
  var extraParams = {
    type: TypeEnum.PAGE,
    req_id: reqId !== null && reqId !== void 0 ? reqId : '',
    view_name: viewName !== null && viewName !== void 0 ? viewName : CreatorListViewModeEnum.Table,
    page_type: pageType !== null && pageType !== void 0 ? pageType : PageType.Default,
    search_key: searchKey !== null && searchKey !== void 0 ? searchKey : '',
    search_param: searchParam !== null && searchParam !== void 0 ? searchParam : '',
    search_terms: searchTerms !== null && searchTerms !== void 0 ? searchTerms : '',
    result_cnt: resultCnt !== null && resultCnt !== void 0 ? resultCnt : 0,
    enter_from: enterFrom !== null && enterFrom !== void 0 ? enterFrom : '',
    tab_name: tabName,
    in_filter_experiment_group: inFilterExperimentGroup ? '1' : '0'
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_SHOW,
    extraParams: extraParams
  });
};
export var trackCreatorMarketplaceButtonClick = function trackCreatorMarketplaceButtonClick(params, clickFor, author) {
  var reqId = params.reqId,
    pageType = params.pageType,
    searchKey = params.searchKey,
    searchParam = params.searchParam,
    searchTerms = params.searchTerms,
    resultCnt = params.resultCnt,
    settingType = params.settingType,
    tabName = params.tabName,
    viewName = params.viewName,
    moduleName = params.moduleName;
  var extraParams = {
    req_id: reqId !== null && reqId !== void 0 ? reqId : '',
    page_type: pageType !== null && pageType !== void 0 ? pageType : PageType.Default,
    search_key: searchKey !== null && searchKey !== void 0 ? searchKey : '',
    search_param: searchParam !== null && searchParam !== void 0 ? searchParam : '',
    search_terms: searchTerms !== null && searchTerms !== void 0 ? searchTerms : '',
    result_cnt: resultCnt !== null && resultCnt !== void 0 ? resultCnt : 0,
    click_for: clickFor,
    setting_type: settingType !== null && settingType !== void 0 ? settingType : '',
    tab_name: tabName,
    view_name: viewName !== null && viewName !== void 0 ? viewName : '',
    module_name: moduleName !== null && moduleName !== void 0 ? moduleName : ''
  };
  if (author) {
    extraParams.author_id = author.authorId;
    extraParams.author_sort = author.authorSort;
    extraParams.campaign_type = author.campaignType || '';
    if (author.isRecommend || author.isRecommendIcon) {
      extraParams.setting_type = author.isRecommendIcon ? SettingType.RecommendedIcon : SettingType.Recommended;
    }
  }
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackCreatorMarketplacePageDuration = function trackCreatorMarketplacePageDuration(duration) {
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_DURATION,
    extraParams: {
      type: TypeEnum.PAGE,
      duration: duration
    }
  });
};
export var trackCreatorExposure = function trackCreatorExposure(params, otherParams) {
  var viewName = params.viewName,
    pageType = params.pageType,
    authorId = params.authorId,
    authorSort = params.authorSort,
    searchKey = params.searchKey,
    searchParam = params.searchParam,
    searchTerms = params.searchTerms,
    settingType = params.settingType,
    reqId = params.reqId,
    tabName = params.tabName;
  var extraParams = _objectSpread({
    type: TypeEnum.MODULE,
    module_name: MODULE_NAME,
    view_name: viewName !== null && viewName !== void 0 ? viewName : CreatorListViewModeEnum.Table,
    page_type: pageType !== null && pageType !== void 0 ? pageType : PageType.Default,
    author_id: authorId !== null && authorId !== void 0 ? authorId : '',
    author_sort: authorSort !== null && authorSort !== void 0 ? authorSort : 0,
    search_key: searchKey !== null && searchKey !== void 0 ? searchKey : '',
    search_param: searchParam !== null && searchParam !== void 0 ? searchParam : '',
    search_terms: searchTerms !== null && searchTerms !== void 0 ? searchTerms : '',
    setting_type: settingType !== null && settingType !== void 0 ? settingType : '',
    req_id: reqId !== null && reqId !== void 0 ? reqId : '',
    tab_name: tabName
  }, otherParams);
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_SHOW,
    extraParams: extraParams
  });
};
export var trackCreatorListHoverEvent = function trackCreatorListHoverEvent(params) {
  var tab_name = params.tabName,
    view_name = params.viewName,
    _params$hoverName = params.hoverName,
    hover_name = _params$hoverName === void 0 ? '' : _params$hoverName;
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_SHOW,
    extraParams: {
      page_name: PageNameEnum.CreatorMarketplace,
      type: TypeEnum.HOVER,
      tab_name: tab_name,
      view_name: view_name,
      hover_name: hover_name
    }
  });
};
export var trackCreatorListDividerExposure = function trackCreatorListDividerExposure(tabName) {
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_SHOW,
    extraParams: {
      page_name: PageNameEnum.CreatorMarketplace,
      type: TypeEnum.MODULE,
      tab_name: tabName,
      module_name: 'gpm_not_referable'
    }
  });
}; /**
   * collection creator list
   */
export var CollectionCreatorModuleNameEnum = /*#__PURE__*/function (CollectionCreatorModuleNameEnum) {
  CollectionCreatorModuleNameEnum["CREATOR_MARKETPLACE_CREATOR_CARD"] = "affiliate_find_creator_card";
  return CollectionCreatorModuleNameEnum;
}({});
export var trackCollectionCreatorButtonClick = function trackCollectionCreatorButtonClick(_ref) {
  var params = _ref.params,
    clickFor = _ref.clickFor,
    _ref$authorId = _ref.authorId,
    authorId = _ref$authorId === void 0 ? '' : _ref$authorId,
    _ref$moduleName = _ref.moduleName,
    moduleName = _ref$moduleName === void 0 ? '' : _ref$moduleName,
    campaignType = _ref.campaignType,
    pageType = _ref.pageType,
    searchKey = _ref.searchKey,
    reqId = _ref.reqId;
  var tabName = params.tabName,
    viewName = params.viewName;
  var extraParams = {
    tab_name: tabName,
    click_for: clickFor,
    campaign_type: campaignType || '',
    page_type: pageType !== null && pageType !== void 0 ? pageType : PageType.Default
  }; // optional
  authorId && (extraParams.author_id = authorId);
  moduleName && (extraParams.module_name = moduleName);
  viewName && (extraParams.view_name = viewName);
  searchKey && (extraParams.search_key = searchKey);
  reqId && (extraParams.req_id = reqId);
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
var collectionCreatorListTrack = new Track({
  pageName: PageNameEnum.CreatorMarketplace,
  extraCommonParams: {
    type: TypeEnum.POPUP,
    popup_name: 'affiliate_saved_creators'
  }
});
export var trackCollectionCreatorDrawerShow = function trackCollectionCreatorDrawerShow(_ref2) {
  var enterFrom = _ref2.enterFrom;
  var extraParams = {
    enter_from: enterFrom
  };
  collectionCreatorListTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_SHOW,
    extraParams: extraParams
  });
};
export var CollectionCreatorListClickForEnum = /*#__PURE__*/function (CollectionCreatorListClickForEnum) {
  CollectionCreatorListClickForEnum["SEARCH"] = "search";
  CollectionCreatorListClickForEnum["SEARCH_SUGGESTION"] = "search_suggestion";
  CollectionCreatorListClickForEnum["FOLLOWERS_FILTER"] = "followers_filter";
  CollectionCreatorListClickForEnum["BATCH_INVITE"] = "batch_invite";
  CollectionCreatorListClickForEnum["BATCH_INVITE_CONFIRM"] = "batch_invite_confirm";
  CollectionCreatorListClickForEnum["BATCH_INVITE_CANCEL"] = "batch_invite_cancel";
  CollectionCreatorListClickForEnum["FOLLOWERS_SORT"] = "followers_sort";
  CollectionCreatorListClickForEnum["VIDEO_VIEWS_SORT"] = "video_views_sort";
  CollectionCreatorListClickForEnum["LIVE_VIEWERS_SORT"] = "live_viewers_sort";
  return CollectionCreatorListClickForEnum;
}({});
export var trackCollectionCreatorListButtonClick = function trackCollectionCreatorListButtonClick(_ref3) {
  var clickFor = _ref3.clickFor,
    suggestionKeyword = _ref3.suggestionKeyword,
    authorIds = _ref3.authorIds;
  var extraParams = {
    click_for: clickFor
  };
  (suggestionKeyword === null || suggestionKeyword === void 0 ? void 0 : suggestionKeyword.length) && (extraParams.suggestion_keyword = suggestionKeyword);
  (authorIds === null || authorIds === void 0 ? void 0 : authorIds.length) && (extraParams.author_ids = authorIds);
  collectionCreatorListTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackCollectionCreatorCardButtonClick = function trackCollectionCreatorCardButtonClick(_ref4) {
  var clickFor = _ref4.clickFor,
    authorId = _ref4.authorId;
  var extraParams = {
    module_name: 'affiliate_saved_creators_card',
    click_for: clickFor,
    author_id: authorId
  };
  collectionCreatorListTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackInputTooltipHoverEvent = function trackInputTooltipHoverEvent(tab_name) {
  var extraParams = {
    tab_name: tab_name,
    type: TypeEnum.HOVER,
    hover_name: 'search_tip'
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_SHOW,
    extraParams: extraParams
  });
};
export var trackSearchResultDividerExposure = function trackSearchResultDividerExposure(_ref5) {
  var tabName = _ref5.tabName,
    query = _ref5.query,
    queryType = _ref5.queryType;
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_SHOW,
    extraParams: {
      page_name: PageNameEnum.CreatorMarketplace,
      type: TypeEnum.MODULE,
      tab_name: tabName,
      field_name: getQueryFieldName(query, queryType),
      module_name: 'search_result_dividing_line'
    }
  });
};
export var trackSearchMenuEvent = function trackSearchMenuEvent(_ref6) {
  var tabName = _ref6.tabName,
    query = _ref6.query,
    queryType = _ref6.queryType,
    result = _ref6.result,
    popupName = _ref6.popupName,
    eventName = _ref6.eventName;
  var extraParams = _objectSpread(_objectSpread({
    query: query,
    tab_name: tabName,
    type: TypeEnum.POPUP,
    popup_name: popupName,
    suggestion_result: result
  }, eventName === EventNameEnum.AFFILIATE_PAGE_SHOW ? {
    field_name: getQueryFieldName(result, queryType)
  } : {}), eventName === EventNameEnum.AFFILIATE_BUTTON_CLICK ? {
    click_for: getQueryFieldName(result, queryType)
  } : {});
  creatorMarketplaceTrack.sendLog({
    eventName: eventName,
    extraParams: extraParams
  });
};
export var trackCreatorFilterButtonClick = function trackCreatorFilterButtonClick(_ref7) {
  var clickFor = _ref7.clickFor,
    value = _ref7.value;
  var extraParams = {
    click_for: clickFor,
    value: value
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackColumnTooltipHoverEvent = function trackColumnTooltipHoverEvent(tab_name, hover_name, author_id) {
  var extraParams = {
    tab_name: tab_name,
    type: TypeEnum.HOVER,
    hover_name: hover_name,
    author_id: author_id
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_SHOW,
    extraParams: extraParams
  });
};
export var trackVideoClick = function trackVideoClick(_ref8) {
  var tab_name = _ref8.tab_name,
    clickFor = _ref8.clickFor,
    authorId = _ref8.authorId;
  var extraParams = {
    tab_name: tab_name,
    popup_name: 'video_player',
    click_for: clickFor,
    author_id: authorId
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackCreatorVideoDuration = function trackCreatorVideoDuration(duration, authorId) {
  var extraParams = {
    tab_name: 'affiliate_find_creators',
    popup_name: 'video_player',
    type: TypeEnum.POPUP,
    duration: duration,
    author_id: authorId
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_DURATION,
    extraParams: extraParams
  });
};
export var trackSortClick = function trackSortClick(_ref9) {
  var tab_name = _ref9.tab_name,
    value = _ref9.value;
  var extraParams = {
    tab_name: tab_name,
    click_for: 'sort',
    value: value
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackListModeClick = function trackListModeClick(_ref10) {
  var tab_name = _ref10.tab_name;
  var extraParams = {
    tab_name: tab_name,
    click_for: 'creator_view_toggle'
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackFilterSearchResultShow = function trackFilterSearchResultShow(_ref11) {
  var tab_name = _ref11.tab_name,
    query = _ref11.query,
    result = _ref11.result;
  var extraParams = {
    tab_name: tab_name,
    query: query,
    result: result
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_SHOW,
    extraParams: extraParams
  });
};
export var trackVideoProductClick = function trackVideoProductClick(_ref12) {
  var videoId = _ref12.videoId,
    authorId = _ref12.authorId,
    productId = _ref12.productId,
    productIndex = _ref12.productIndex;
  var extraParams = {
    module_name: videoId,
    popup_name: 'video_player',
    author_id: authorId,
    video_product_id: productId,
    video_product_position: productIndex,
    click_for: 'product_click'
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackVideoViewLinkClick = function trackVideoViewLinkClick(_ref13) {
  var videoId = _ref13.videoId,
    authorId = _ref13.authorId;
  var extraParams = {
    module_name: videoId,
    popup_name: 'video_player',
    author_id: authorId,
    click_for: 'tiktok_video_link'
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackVideoSwitchClick = function trackVideoSwitchClick(_ref14) {
  var videoId = _ref14.videoId,
    authorId = _ref14.authorId,
    clickFor = _ref14.clickFor;
  var extraParams = {
    module_name: videoId,
    popup_name: 'video_player',
    author_id: authorId,
    click_for: clickFor
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackVideoProductExposure = function trackVideoProductExposure(_ref15) {
  var videoId = _ref15.videoId,
    productId = _ref15.productId;
  var extraParams = {
    module_name: videoId,
    popup_name: 'video_player',
    type: TypeEnum.MODULE,
    video_product_id: productId
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_SHOW,
    extraParams: extraParams
  });
};
export var trackTargetInvitationCreatorFilterClick = function trackTargetInvitationCreatorFilterClick(params) {
  var clickFor = params.clickFor,
    type = params.type;
  var extraParams = {
    type: type,
    tab_name: 'creator_detail',
    module_name: 'campaign',
    click_for: clickFor
  };
  targetInvitationListTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackAddCreatorsToCRM = function trackAddCreatorsToCRM(_ref16) {
  var pageName = _ref16.pageName,
    authorId = _ref16.authorId,
    pageType = _ref16.pageType,
    searchKey = _ref16.searchKey;
  var extraParams = {
    click_for: 'add_to_crm',
    page_name: pageName,
    author_id: authorId,
    search_key: searchKey || '',
    page_type: pageType !== null && pageType !== void 0 ? pageType : PageType.Default
  };
  creatorMarketplaceTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var TargetInvitationFilterClickType = /*#__PURE__*/function (TargetInvitationFilterClickType) {
  TargetInvitationFilterClickType["CREATOR_TAG"] = "creator_tag";
  TargetInvitationFilterClickType["FOLLOWERS"] = "followers";
  TargetInvitationFilterClickType["SAVED_FROM_CREATOR_CONNECT"] = "saved_from_creator_connect";
  TargetInvitationFilterClickType["UNVITED"] = "unvited";
  TargetInvitationFilterClickType["ADD"] = "add";
  return TargetInvitationFilterClickType;
}({});
var targetInvitationTrack = new Track({
  pageName: PageNameEnum.TargetInvitationForm
});
export var trackTargetInvitationFilterClick = function trackTargetInvitationFilterClick(_ref17) {
  var click_for = _ref17.click_for;
  var extraParams = {
    click_for: click_for,
    type: TypeEnum.MODULE,
    module_name: 'choose_from_creator',
    result: 'added_successful'
  };
  targetInvitationTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackUploadButtonClick = function trackUploadButtonClick() {
  var extraParams = {
    click_for: 'upload_on_seller_center'
  };
  targetInvitationTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_BUTTON_CLICK,
    extraParams: extraParams
  });
};
export var trackUploadAlertShow = function trackUploadAlertShow() {
  var extraParams = {
    type: TypeEnum.MODULE,
    module_name: 'shop_profile_missing_notification'
  };
  targetInvitationTrack.sendLog({
    eventName: EventNameEnum.AFFILIATE_PAGE_SHOW,
    extraParams: extraParams
  });
};